import $ from 'jquery';
import gallerySlider from './gallery-slider';

const modal = (el) => {
    const $gallery = $(el);
    const $modal = $gallery.next('.js-modal');
    const $images = $gallery.find('.js-open-modal');
    const $close = $modal.find('.js-close-modal');
    const $expandBtn = $gallery.find('.js-expand-gallery');

    if($images.length) {
        $images.each(function () {
            $(this).on('click', (e) => {
                e.preventDefault();
                const index = $(this).data('image-index');
                const $image = $modal.find(`[data-image-index="${index}"]`);
                $modal.fadeIn('fast');
                $image.addClass('js-current-modal-image');

                gallerySlider($modal, index);
            })
        });
    }

    if($close.length) {
        $close.on('click', () => {
            $modal.fadeOut('fast');
            $modal.find('[data-image-index]').removeClass('js-current-modal-image');
        });
    }

    if($expandBtn.length) {
        $expandBtn.on('click', () => {
            $gallery.addClass('js-state-gallery-expanded');
            $gallery.find('[data-image-index]').fadeIn('fast');
        });
    }
}

export default modal;
